/* unplugin-vue-components disabled */import script from "./YourAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./YourAccount.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__